import React from "react";
import { useState } from "react";
import { FunctionComponent } from "react";

//All components imported, then exported
import Column from "./components/column";
import Row from "./components/row";
import Empty from "./components/empty";
import Display from "./components/display";
import DisplayTable from "./components/displayTable";
import Button from "./components/button";
import ToggleButton from "./components/toggleButton";
import CounterButton from "./components/counterButton";
import TextEntry from "./components/textEntry";
import OverlaySelection from "./components/overlaySelection";

export {
    Column,
    Row,
    Empty,
    Display,
    DisplayTable,
    Button,
    ToggleButton,
    CounterButton,
    TextEntry,
    OverlaySelection
}

export function SubmitData (body: string, datatype: string, route: string) {
    const fetchRoute = process.env.REACT_APP_SERVER_URL + route;

    //gets cached data and adds the new data to it
    const data = JSON.parse(localStorage.getItem('cached') || "[]");
    data.push(
        {
            datatype: datatype,
            data: body
        }
    );
    console.log("data: " + JSON.stringify(data))

    //sends data to server
    fetch(fetchRoute, {
        method: 'POST',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': process.env.REACT_APP_SERVER_URL || "http://localhost:5000",
            'Version': process.env.REACT_APP_VERSION || "0.0.0"
        },
        body: JSON.stringify(
            {
                data: data,
                password: localStorage.getItem('teamPassword') || "password"
            }
        )
    }).then((response) => {
        localStorage.setItem('cached', JSON.stringify([]));
        console.log(response);
        if (response.status === 403) {
            window.confirm("Version outdated. Please force update. Data invalidated.");
        } else {
            window.confirm("Data successfully sent to server.");
        }
    }).catch((err) => {
        localStorage.setItem('cached', JSON.stringify(data));
        console.log(err);
        window.confirm("Unable to send data to server. Retry or attempt at another location.");
    });
}

export function SubmitButton ({label = "Label", width = "25vw", height = "25vh", color = "red", data = "null", route = "null", datatype = "null"}) {
    const [overlay, setOverlay] = useState(false);
    
    console.log(label)

    const tileStyle = {
        width: width,
        height: height,
    }


    if (data === "null" || route === "null") {
        return (
            <div className="tile" style={tileStyle}>
                <h1>Invalid Data/Route</h1>
            </div>
        )
    }

    function submit() {
        SubmitData(data, datatype, route);
        setOverlay(true);
    }

    return (
        <div className="tile" style={tileStyle}>
            <div id="submitbtn" onClick={() => {submit()}} style={{backgroundColor: color}}>
                    <h1>{"Submit Information"}</h1>
            </div>
            <div className="overlay" style={Object.assign({display: overlay})}>
                <h1>Connecting to server</h1>
                <Row>
                    {/* <GenerateQRCode data={data = listToCSV(qrData)} /> */}
                        <div onClick={() => SubmitData(data, datatype, route)}>
                            <h1>Retry</h1>
                        </div>
                </Row>
                <div className="new data">
                    <div onClick={() => window.location.reload()}>
                        <h1>Reset Form</h1>
                    </div>
                </div>
                <div className="exitOverlay">
                    <div onClick={() => setOverlay(false)}>
                        <h1>Exit Overlay</h1>
                    </div>
                </div>
            </div>
        </div>
    )
}

export const Lib = (option: string): FunctionComponent<any> | null => {
    switch (option) {
        // case "Orientation":
        //     return Orientation;
        case "Row":
            return Row;
        case "Column":
            return Column;
        case "Empty":
            return Empty;
        case "Display":
            return Display;
        case "DisplayTable":
            return DisplayTable;
        case "Button":
            return Button;
        case "ToggleButton":
            return ToggleButton;
        case "CounterButton":
            return CounterButton;
        case "TextEntry":
            return TextEntry;
        case "OverlaySelection":
            return OverlaySelection;
        case "SubmitButton":
            return SubmitButton;
        default:
            return null;
    }
}